import React from "react";
import Lightbox from "react-images-and-youtube";
import { styles } from "./Gallery.style";

export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lightboxImages: props.images.map(image => {
        image.src = image.url;
        return image;
      }),
      currentImage: 0,
      isOpen: false
    };
  }

  goToNext() {
    if (this.props.images.length - 1 > this.state.currentImage) {
      this.setState({
        currentImage: this.state.currentImage + 1
      });
    }
  }

  goToPrev() {
    if (this.state.currentImage > 0) {
      this.setState({
        currentImage: this.state.currentImage - 1
      });
    }
  }

  open() {
    this.setState({
      isOpen: true
    });
  }

  close() {
    this.setState({
      isOpen: false
    });
  }

  render() {
    return (
      <div className={styles.gallery()}>
        <div className={styles.face()} onClick={this.open.bind(this)}>
          <div className={styles.viewPromptWrap({ className: "d-md-none" })}>
            <img
              className={styles.viewPromptIcon()}
              src="/static/icons/play.svg"
              alt=""
            />
          </div>

          <div className={styles.previewWrap()}>
            <div className={styles.previewImageWrap()}>
              <img
                className={styles.previewImage()}
                src={this.props.images[0].url}
                alt=""
              />
            </div>
            {this.props.images.length > 1 && (
              <div
                className={styles.previewImageWrap({
                  className: "d-none d-md-block d-lg-block d-xl-block"
                })}
              >
                <img
                  loading="lazy"
                  className={styles.previewImage()}
                  src={this.props.images[1].url}
                  alt=""
                />
              </div>
            )}
          </div>
        </div>

        <Lightbox
          images={this.state.lightboxImages}
          currentImage={this.state.currentImage}
          isOpen={this.state.isOpen}
          onClickPrev={this.goToPrev.bind(this)}
          onClickNext={this.goToNext.bind(this)}
          onClose={this.close.bind(this)}
          backdropClosesModal={true}
        />
      </div>
    );
  }
}
